<template>
  <view>
    <yi-create-order-batch
      :orderData="orderForm"
      :selectPid="selectPid"
      :selectPick="selectPick"
      @gotoPickList="gotoPickList"
    />
  </view>
</template>

<script>
export default {
  name: 'newOrder',
  data() {
    return {
      orderForm: null,
      orderFormOriginal: null,
      selectPid: null, //配送方式为2: 自提的时候, 取货点/门店id
      selectPick: null, //选择的取货点/门店信息
    };
  },
  onLoad(query) {
    console.log('%c [参数]: ', 'color:#1989fa;', JSON.parse(query.orderForm));
    this.orderForm = JSON.parse(query.orderForm);
    // this.orderFormOriginal = JSON.parse(query.orderForm);
  },
  methods: {
    gotoPickList() {
      uni.navigateTo({ url: '/demo/packageMall/pickList' });
    },
  },
};
</script>

<style scoped></style>
